import Modal from "../Modal/Modal";
import { useState } from "react";
import "./editTask.css";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

function EditTask({
  open,
  onClose,
  toEditName,
  toEditSurname,
  toEditUsername,
  toEditAge,
  toEditFollowers,
  toEditCity,
  toEditEmail,
  id,
}) {
  const [name, setName] = useState(toEditName);
  const [surname, setSurname] = useState(toEditSurname);
  const [username, setUsername] = useState(toEditUsername);
  const [followers, setFollowers] = useState(toEditFollowers);
  const [city, setCity] = useState(toEditCity);
  const [age, setAge] = useState(toEditAge);
  const [email, setEmail] = useState(toEditEmail);

  /* function to update firestore */
  const handleUpdate = async (e) => {
    e.preventDefault();
    const taskDocRef = doc(db, "users", id);
    try {
      await updateDoc(taskDocRef, {
        name: name,
        surname: surname,
        username: username,
        email: email,
        followers: followers,
        age: age,
        city: city,
      });
      onClose();
    } catch (err) {
      alert(err);
    }
  };

  return (
    <Modal modalLable="Edit Task" onClose={onClose} open={open}>
      <form onSubmit={handleUpdate} className="editTask">
        <input
          type="text"
          name="name"
          onChange={(e) => setName(e.target.value.toUpperCase())}
          value={name}
        />
        <input
          type="text"
          name="surname"
          onChange={(e) => setSurname(e.target.value)}
          value={surname}
        />
        <input
          type="text"
          name="username"
          onChange={(e) => setUsername(e.target.value)}
          value={username}
        />
        <input
          type="text"
          name="age"
          onChange={(e) => setAge(e.target.value)}
          value={age}
        />
        <input
          type="text"
          name="followers"
          onChange={(e) => setFollowers(e.target.value)}
          value={followers}
        />
        <input
          type="text"
          name="email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
        />
        <input
          type="text"
          name="city"
          onChange={(e) => setCity(e.target.value)}
          value={city}
        />
        <button type="submit">Edit</button>
      </form>
    </Modal>
  );
}

export default EditTask;
